// extracted by mini-css-extract-plugin
export default {"Trigger":"linked-pr-list-module__Trigger__pUwnAFd","Number":"linked-pr-list-module__Number__ue3j2JJ"};